import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { LoginResponse } from '../types/LoginResponse.type';
import {ActionService} from "./action.service";

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private autenticado = false;

  constructor(private httpClient: HttpClient, private configService: ConfigService, private actionService: ActionService) {
    this.autenticado = !!localStorage.getItem("auth-token")
   }

  login(email: string, senha: string){
    return this.httpClient.post<LoginResponse>(`${this.configService.getApiUrl()}/auth/login`, { email, senha}).pipe(
      tap((value) => {
        localStorage.setItem("auth-token", value.token)
        localStorage.setItem("nomeUsuario", value.nomeUsuario)
        // localStorage.setItem("api-secret", value.apiSecret)
        localStorage.setItem("emailUsuario", value.email)
        localStorage.setItem("roles", JSON.stringify(value.roles))
        localStorage.setItem("cdUsuarioErp", value.cdUsuarioErp)
        localStorage.setItem("actions", JSON.stringify(value.actions))

        this.actionService.loadActions();

        this.autenticado = true
      })
    )
  }

  redefinir(email: string, token: string, senha: string){
    return this.httpClient.put(`${this.configService.getApiUrl()}/usuario/redefinir`, { email, token, senha})
  }

  solicitacaoRedefinicao(email: string){
    return this.httpClient.post(`${this.configService.getApiUrl()}/usuario/redefinicaoSenha`, {email})
  }

  isAutenticado(): boolean{
    return this.autenticado
  }

  getToken(): string {
    return localStorage.getItem("auth-token") || ''
  }

  getApiSecret(): string {
    var ambiente = localStorage.getItem("ambiente");
    var codigo = "";
    if(ambiente != null) codigo = JSON.parse(ambiente).codigo
    return codigo;
  }

  getUsuario(): string {
    return localStorage.getItem("emailUsuario") || ''
  }
}
